<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2oPIlg/images/Cover.jpg?1708005252240" alt="This image is the cover for the book Ghosts and Legends of Hollywood, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghosts and Legends of Hollywood, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Cursed awards, haunted estates, and deadly sets. </b></p> <p>Hollywood is supposed to be the place where dreams come true, but it's also where nightmares come to life. Spirits haunt the halls of renowned studios, legendary cafes, and lavish estates, while rumors of curses lurk in the shadows of the rich and famous. It's said that stars like James Dean, Carrie Fisher, and Prince once predicted their own deaths, while slain screenwriter Paul Bern tried in vain to warn Sharon Tate about her own fate. Ghosts reportedly linger in the corners of the El Coyote Café and the Falcon Lair boasts sightings of Rudolph Valentino long after his death.</p> <p>Join author and paranormal historian Brian Clune for a star-studded tour of the dark side of Hollywood.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Clune
      </h2>
      
      <p class="authorDescription body article">Hollywood is supposed to be the place where dreams come true, but it's also where nightmares come to life. Spirits haunt the halls of renowned studios, legendary cafés and lavish estates, while rumors of curses lurk in the shadows of the rich and famous. It's said that stars like James Dean, Carrie Fisher and Prince once predicted their own deaths, while slain screenwriter Paul Bern tried in vain to warn Sharon Tate about her own fate. Ghosts reportedly linger in the corners of the El Coyote Café, and the Falcon Lair boasts sightings of Rudolph Valentino long after his death. Join author and paranormal historian Brian Clune for a star-studded tour of the dark side of Hollywood.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9da53dbe